import React from 'react';

const MENTOR_INSTAGRAMS = [
  {
    name: 'Kojo Forex',
    username: 'kojoforex',
    location: 'Ghana'
  },
  {
    name: 'LightTrade Forex',
    username: 'lighttradeforex',
    location: 'Africa'
  }
];

function formatFollowers(count) {
  if (typeof count !== 'number') return '—';
  return new Intl.NumberFormat().format(count);
}

export default function Mentors() {
  const [statsByUsername, setStatsByUsername] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    document.title = 'Mentors | LightTrade FOREX Academy';

    const load = async () => {
      try {
        setLoading(true);
        setError('');

        const results = await Promise.all(
          MENTOR_INSTAGRAMS.map(async (mentor) => {
            const res = await fetch(`/api/instagram-followers?username=${encodeURIComponent(mentor.username)}`);
            const payload = await res.json();

            if (!res.ok) {
              throw new Error(payload?.details || payload?.error || `Request failed for @${mentor.username}`);
            }

            return [mentor.username, payload];
          })
        );

        setStatsByUsername(Object.fromEntries(results));
      } catch (err) {
        setError(err.message || 'Failed to load mentor stats.');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <section className="home-hero" style={{ minHeight: '60vh' }}>
      <div className="hero-content" style={{ maxWidth: 900 }}>
        <h1>Mentors</h1>
        <p>Live Instagram audience snapshots for each mentor account.</p>

        {loading && <p>Loading latest counts…</p>}
        {!loading && error && <p style={{ color: '#c62828' }}>{error}</p>}

        {!loading && !error && (
          <div style={{ display: 'grid', gap: 14, marginTop: 18 }}>
            {MENTOR_INSTAGRAMS.map((mentor) => {
              const data = statsByUsername[mentor.username];

              return (
                <article
                  key={mentor.username}
                  style={{ background: '#fff', color: '#143a5c', borderRadius: 12, padding: 20 }}
                >
                  <h3 style={{ marginTop: 0, marginBottom: 6 }}>{mentor.name}</h3>
                  <p style={{ marginTop: 0 }}>
                    <a
                      href={`https://www.instagram.com/${mentor.username}/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      @{mentor.username}
                    </a>
                    {mentor.location ? ` · ${mentor.location}` : ''}
                  </p>
                  <p style={{ fontSize: 28, fontWeight: 700, margin: '8px 0' }}>
                    {formatFollowers(data?.followers)} followers
                  </p>
                  <p style={{ margin: 0 }}>
                    Last checked: {data?.updatedAt ? new Date(data.updatedAt).toLocaleString() : 'Unknown'}
                  </p>
                  {data?.stale && (
                    <p style={{ color: '#8a6d3b', marginTop: 8, marginBottom: 0 }}>
                      Showing cached value because Instagram temporarily rate-limited live fetch.
                    </p>
                  )}
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
